import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3800929241/src/src/app/ui/common/side-menu.tsx");
